import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('firmware', { params }).then(result => result.data)
  }
}
